import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const linksService = {
  getAll,
  createOrUpdate,
  deleteLink
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/usefull_links/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newLink) {
  const requestOptions = {
    method: newLink.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newLink)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/usefull_links${
    newLink.id ? `/${newLink.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(link) {
  let formData = new FormData();

  formData.append('usefull_link[title]', link.title);
  formData.append('usefull_link[link]', link.link);
  formData.append('usefull_link[description]', link.description);
  const document = link.document;

  if (document) {
    if (document.url) {
      formData.append(`usefull_link[document]`, document.url);
    } else {
      formData.append(`usefull_link[document]`, document, document.name);
    }
  }

  return formData;
}
function deleteLink(linkId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/usefull_links/${linkId}`;

  return axios.delete(url, requestOptionsDelete);
}
